import React from 'react';
import { Icon } from './Icon.js';
export const IconLabel = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m4.72,6.4l4-3.333c.742-.618,1.819-.618,2.561,0l4,3.333c.456.38.72.943.72,1.536v6.063c0,1.657-1.343,3-3,3h-6c-1.657,0-3-1.343-3-3v-6.063c0-.594.264-1.156.72-1.536Z", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }),
        React.createElement("circle", { cx: "10", cy: "8.25", r: "1.25", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconLabel.js.map